<template>
  <div>
    <page-header>
      <template #title>
        <h1 class="page-title">
          PDI
        </h1>
      </template>
    </page-header>

    <div v-if="!loading">
      <div class="card mb-4">
        <div class="card-body text-center">
          <template v-if="!completed && !completing">
            <template v-if="pdi?.vehicle">
              <strong>Vehicle</strong>
              <br />
              <span v-if="pdi?.vehicle?.make"
                >{{ pdi?.vehicle?.make?.label }} -
              </span>
              <span v-if="pdi?.vehicle?.model"
                >{{ pdi?.vehicle?.model }} -
              </span>
              {{ pdi?.vehicle?.registration }}
            </template>

            <template v-if="pdi.completed_at">
              <p>
                Job completed by {{ pdi.completedBy.full_name }} at
                {{ pdi.completed_at | date }}
              </p>

              <form-button
                level="primary"
                :indicator="downloading"
                @clicked="downloadStatement()"
              >
                Download PDF
              </form-button>
            </template>
          </template>

          <template v-if="completed && !completing">
            <br />
            <p>
              Thank you for completing the statement, please click the link
              below to the PDI queue
            </p>
            <button type="button" class="btn btn-primary" @click="goToQueue()">
              Back To PDI Queue
            </button>
          </template>

          <template v-if="completing">
            <preloader></preloader>
          </template>
        </div>
      </div>

      <div class="bail-integration">
        <statement-renderer
          id="statement-renderer"
          :editable="editable"
          :statement="statement"
          :base-url="aisApiUrl"
          navigation="steps"
          @completed="statementCompleted()"
          v-if="!completed"
        ></statement-renderer>
      </div>
    </div>
    <div v-else>
      <preloader></preloader>
    </div>
  </div>
</template>

<script>
import PageHeader from './../Shared/PageHeader.vue';

export default {
  components: {
    PageHeader
  },

  props: {
    id: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      loading: true,
      pdi: null,
      statement: null,
      editable: true,
      downloading: false,
      completed: false,
      completing: false
    };
  },

  computed: {
    aisApiUrl() {
      return window.AxisUK.ais.api;
    }
  },

  mounted() {
    Promise.all([
      window.Ajax.get(`pdi/${this.id}?parts=vehicle,abiGroup,completedBy`),
      window.Ajax.get(`pdi/${this.id}/statement`)
    ])
      .then(([pdi, statement]) => {
        this.pdi = pdi.data;
        this.statement = JSON.stringify(statement.data);

        if (statement.data.completed_at) {
          this.editable = false;
        }

        this.loading = false;
      })
      .catch(() => {
        window.toastify.error(
          'Oops',
          'An error occurred while loading the PDI'
        );
      });
  },

  methods: {
    downloadStatement() {
      this.downloading = true;

      window.Ajax.download(`pdi/${this.id}/download`)
        .then(() => (this.downloading = false))
        .catch(() => {
          this.downloading = false;

          window.toastify.error(
            'Oops',
            'An error occurred while downloading the PDF'
          );
        });
    },

    statementCompleted() {
      this.completing = true;

      window.Ajax.post(`pdi/${this.id}/complete`)
        .then(() => {
          this.completed = true;
          this.completing = false;
        })
        .catch(() => {
          this.completing = false;

          window.toastify.error(
            'Oops',
            'An error occurred while completing the PDI'
          );
        });
    },

    goToQueue() {
      this.route('/pdi-queue');
    }
  }
};
</script>
